/**
 * Navbar & Drawer Interactions
 * - Hamburger toggle (mobile)
 * - Drawer open/close
 * - Drawer subnav accordion
 * - Desktop dropdown hover via menu-open class
 */

(function () {
document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.querySelector('.hamburger');
  const drawer = document.querySelector('.drawer');
  const overlay = document.querySelector('.drawer-overlay');
  const closeBtn = document.querySelector('.drawer-close');
  const toggles = document.querySelectorAll('.drawer-toggle');
  const navItems = document.querySelectorAll('.nav-item.has-children');

  function openDrawer() {
    hamburger.classList.add('active');
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    hamburger.classList.remove('active');
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Hamburger button toggle
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (drawer.classList.contains('active')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  // Overlay click closes drawer
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  // Drawer subnav accordion toggle
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const subnav = this.closest('.drawer-item').querySelector('.drawer-subnav');
      if (subnav) {
        subnav.classList.toggle('expanded');
        this.classList.toggle('expanded');
      }
    });
  });

  // Close drawer when a link is clicked (except toggles)
  const drawerLinks = drawer.querySelectorAll('.drawer-item-header a, .drawer-subnav a, .drawer-utility a');
  drawerLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });

  // Desktop dropdown hover behavior (menu-open class)
  // On hover, add menu-open class to nav-item to show dropdown
  navItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      this.classList.add('menu-open');
    });
    item.addEventListener('mouseleave', function () {
      this.classList.remove('menu-open');
    });
  });

  // Optional: Keyboard support for desktop dropdowns
  // Close dropdown on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      navItems.forEach(function (item) {
        item.classList.remove('menu-open');
      });
    }
  });
});
})();
